import { useCallback, useEffect, useState } from 'react';
import { computeDropSlotVirtualRange } from './use-variant-slot-metrics';

type UseDropSlotViewportOptions = {
  scrollContainerRef: React.RefObject<HTMLDivElement | null>;
  rows: number[];
  orderRowsHeight: number;
  variantId: string;
  visibleCount: number;
};

export function useDropSlotViewport({
  scrollContainerRef,
  rows,
  orderRowsHeight,
  variantId,
  visibleCount,
}: UseDropSlotViewportOptions) {
  const [scrollTop, setScrollTop] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(320);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const updateViewport = () => setViewportHeight(container.clientHeight);
    updateViewport();

    const resizeObserver = new ResizeObserver(updateViewport);
    resizeObserver.observe(container);
    return () => resizeObserver.disconnect();
  }, [scrollContainerRef, variantId, visibleCount]);

  const virtualRange = computeDropSlotVirtualRange({
    rows,
    scrollTop,
    viewportHeight,
    orderRowsHeight,
  });

  const handleScroll = useCallback((nextScrollTop: number) => {
    setScrollTop((prev) => (prev === nextScrollTop ? prev : nextScrollTop));
  }, []);

  return { viewportHeight, virtualRange, handleScroll };
}
